import { ProductionGroup } from '@paragon/contract-library';

export function getProductionGroupName(productionGroup: ProductionGroup, includeProjectInfo: boolean) {
  const { projectId, projectShortName, buildingType, buildingInstance, level } = productionGroup;
  const projectInfo = includeProjectInfo ? `${projectId === null ? '' : `${projectId} `}${projectShortName}: ` : '';
  return `${projectInfo}${buildingType}${buildingInstance === null ? '' : `-${buildingInstance}`}${
    level === null ? '' : ` Level ${level}`
  }`;
}
